import { useEffect } from 'react';

interface BreadcrumbItem {
  label: string;
  url: string;
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}

/**
 * BreadcrumbSchema Component
 * 
 * Injects BreadcrumbList structured data (Schema.org) into the page head
 * to help search engines understand site hierarchy and display rich breadcrumb trails
 * in search results.
 * 
 * @param items - Array of breadcrumb items with label and URL
 */
export default function BreadcrumbSchema({ items }: BreadcrumbSchemaProps) {
  useEffect(() => {
    // Create BreadcrumbList schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.label,
        "item": `https://danispainting.net${item.url}`
      }))
    };

    // Check if breadcrumb schema already exists
    let schemaScript = document.querySelector('script[type="application/ld+json"][data-schema="breadcrumb"]');
    
    if (!schemaScript) {
      // Create new script element
      schemaScript = document.createElement('script');
      schemaScript.setAttribute('type', 'application/ld+json');
      schemaScript.setAttribute('data-schema', 'breadcrumb');
      document.head.appendChild(schemaScript);
    }
    
    // Update script content
    schemaScript.textContent = JSON.stringify(breadcrumbSchema);

    // Cleanup function
    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"][data-schema="breadcrumb"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [items]);

  return null; // This component doesn't render anything visible
}
